import { inject } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import { Store } from '@ngrx/store';
import { selectGeneralAuth } from '../../store/auth/auth.selectors';
import {filter, map, take} from 'rxjs';
import {CurrentUserService} from "../services/current-user.service";
import {SharedUtils} from "../services/utils/shared-utils.service";
import {MessageUtilsService} from "../services/utils/message-utils.service";
import {switchMap} from "rxjs/operators";

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const store = inject(Store);
  const currentUserService = inject(CurrentUserService);

  return store.select(selectGeneralAuth).pipe(
    // prima controlla se l'utente è loggato
    map(auth => {
      const loggedIn = auth && (
        (auth.authResponse && auth.authResponse.accessToken?.length > 0) ||
        (auth.firebaseResponse && auth.firebaseResponse._tokenResponse?.idToken)
      );
      if (!loggedIn) {
        router.navigate(['/auth']);
        currentUserService.active = false;
        return null; // utente non loggato
      }
      currentUserService.active = true;
      return true;
    }),
    // se non loggato, termina
    filter(v => v !== null),
    // aspetta finché il CurrentUserService ha caricato l'utente
    switchMap(() =>
      currentUserService.currentUser$.pipe(
        filter(user => !!user), // aspetta che arrivi un utente
        take(1),                // prendi solo il primo valore valido
        map(user => {
          const routePermission = route.data['permission'];
          if (routePermission) {
            if (currentUserService.hasPermission(routePermission)) {
              return true;
            } else {
              console.log('user permission denied', routePermission);
              SharedUtils.instance()
                ?.messageUtils()
                ?.push(
                  MessageUtilsService.Severity.warning,
                  'message.summary.denied',
                  'message.detail.denied'
                );
              router.navigate(['/app']);
              return false;
            }
          }
          return true;
        })
      )
    )
  );
};

export const authGuard_old: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const store = inject(Store);
  const currentUserService = inject(CurrentUserService);

  return store.select(selectGeneralAuth).pipe(

    map((auth) => {
      if (auth && ( (auth.authResponse && auth.authResponse.accessToken.length > 0) || (auth.firebaseResponse && auth.firebaseResponse._tokenResponse.idToken) ) ) {
        currentUserService.active = true
        const routePermission = route.data['permission'];
        if( routePermission){
          if(currentUserService.hasPermission(routePermission)){
            return true
          }{
            console.log('user permission denied', routePermission);
            SharedUtils.instance()?.messageUtils()?.push(MessageUtilsService.Severity.warning, 'message.summary.denied', 'message.detail.denied');
            router.navigate(['/app']);
            return false;
          }
        }
        return true;
      } else {
        router.navigate(['/auth']);
        currentUserService.active= false;
        return false;
      }
    })
  );
};
